import React from "react";
import './LabelBox.css';

interface ILabelBoxProps{
    label: React.ReactNode;
    className?: string;
}

export const LabelBox: React.FC<React.PropsWithChildren<ILabelBoxProps>> = ({label, className, children})=>{
    return <div className={`commonLabelBox ${className || ''}`}>
    <div className="commonLabelBox_label">
        {label}
    </div>
    {children}
</div>
}
